import { render, staticRenderFns } from "./ModifyRoleModal.vue?vue&type=template&id=062cd1d1&scoped=true&"
import script from "./ModifyRoleModal.vue?vue&type=script&lang=ts&"
export * from "./ModifyRoleModal.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyRoleModal.vue?vue&type=style&index=0&id=062cd1d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062cd1d1",
  null
  
)

export default component.exports